import { render, staticRenderFns } from "./dragonpay.vue?vue&type=template&id=c24a6f2a&scoped=true&"
import script from "./dragonpay.vue?vue&type=script&lang=js&"
export * from "./dragonpay.vue?vue&type=script&lang=js&"
import style0 from "./dragonpay.vue?vue&type=style&index=0&id=c24a6f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24a6f2a",
  null
  
)

export default component.exports